import { Snack, Text } from '@nike/eds'
import React from 'react'
import { SimpleTable } from '../../common/components/table/SimpleTable'
import { goodsHolderItemsTableColumns } from './GoodsHolderItemsTableColumns'

export function GoodsHolderItems({ goodsHolderItems }) {
  return goodsHolderItems?.length ? (
    <SimpleTable
      title="Units"
      columns={goodsHolderItemsTableColumns}
      data={goodsHolderItems}
      compact={true}
    />
  ) : (
    <div>
      <Text
        as="h2"
        font="title-3"
        style={{ margin: '0 0 var(--eds-space-8) var(--eds-space-12)' }}
        className="vcenter"
      >
        Units
      </Text>
      <Snack id="no-units-snack" onDismiss={(id) => {}} hideDismiss={true} status="info">
        No Units found
      </Snack>
    </div>
  )
}
